export enum TransitionSpeedEnum {
	TRANSITION_INITIATED = 'transitionInitiated',
	TRANSITION_FINISHED = 'transitionFinished',
	TRANSITION_SPEED = 'transitionSpeed'
}
